'use client';

import SeasonalPromoDialog, {
  type SeasonalPromoDialogProps,
} from '@/components/global/seasonal/SeasonalPromoDialog';

/**
 * Promo popup, "Halloween 2026" design — Figma 12770:42307 (desktop) and
 * 12770:42359 (mobile). The layout lives in SeasonalPromoDialog.
 */
export default function PromoBannerDialogHalloween(
  props: Omit<SeasonalPromoDialogProps, 'theme'>,
) {
  return <SeasonalPromoDialog {...props} theme="halloween" />;
}
